import React from 'react'
import { View, Image, TouchableOpacity } from 'react-native'
import logo from '@assets/imgs/logo.png'
import { Theme } from '../enum/Theme'
import { List } from '@phosphor-icons/react';
import { toggleDrawer } from '../services/NavigationService'
import SpaceW from './SpaceW';

const AppHeader: React.FC = () => {
    return (
        <View style={{ backgroundColor: Theme.foreground, justifyContent: 'center', padding: 4 }}>
            <View style={{ flexDirection: 'row' }}>
                <SpaceW />
                <TouchableOpacity onPress={() => toggleDrawer()} style={{ width: 60, justifyContent: 'center' }}>
                    <List color='#fff' size={40} />
                </TouchableOpacity>
                <SpaceW />
                <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 4 }}>
                    <Image source={logo} style={{ width: '100%', height: 50 }} resizeMode='contain' />
                </View>
                <SpaceW />
            </View>

        </View>
    )
}

export default AppHeader
